module.exports = __webpack_public_path__ + "img/Capitec.8c6815c5.svg";